"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECT2 = void 0;
const vue_1 = __importDefault(require("vue"));
const z = __importStar(require("zod"));
const cell_editor_1 = require("./cell-editor");
const text_1 = require("./text");
const select_1 = require("./select");
const core_1 = require("@integro/core");
const SELECT2_FORMATTER_CONFIG = text_1.TEXT.formatter.schema.extend({});
const SELECT2_EDITOR_CONFIG = select_1.SELECT.editor.schema.extend({
    clearable: z.boolean().default(true),
    closeOnSelect: z.boolean().default(true),
    filterable: z.boolean().default(true),
    filterBy: z.string().optional(),
    options: z.union([
        z.array(z.any()),
        z
            .function()
            .args(z.string())
            .returns(z.promise(z.array(z.any())))
    ]),
    optionValueField: z.string().optional(),
    onOptionSelected: z.function().optional(),
    optionTemplate: z.string().optional(),
    selectedOptionTemplate: z.string().optional()
});
exports.SELECT2 = {
    name: 'select2',
    formatter: {
        schema: SELECT2_FORMATTER_CONFIG,
        createComponent(config) {
            return text_1.TEXT.formatter.createComponent(config);
        }
    },
    editor: {
        schema: SELECT2_EDITOR_CONFIG,
        createComponent(config) {
            return {
                component: {
                    name: 'Select2Editor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<ItpSelect2
              v-model="currentValue"
              v-bind="bindings"
              :autofocus="autofocus"
              :form="formId"
              :tabindex="col.effectiveTabindex"
              :inputId="col.field"
              :size="col.size"
              :state="validationState"
              :disabled="isDisabled"
              @optionSelected="onOptionSelected($event)"
              @change="onChange($event)"
            ></ItpSelect2>`),
                    data() {
                        return {
                            bindings: {
                                ...(0, core_1.deepCopy)(config),
                                selectedOptionTemplate: config.selectedOptionTemplate || config.optionTemplate
                            }
                        };
                    },
                    methods: {
                        onOptionSelected(ev) {
                            this.col.emit(`${this.col.name}:selected`, {
                                col: this.col,
                                row: this.row,
                                ...ev
                            });
                        }
                    }
                }
            };
        }
    }
};
//# sourceMappingURL=select2.js.map